import React, { createContext, useState } from 'react';

export const TabContext = createContext();

const TabProvider = ({ children, tabs }) => {
    const [activeTabTitle, setActiveTabTitle] = useState(null);

    // Derive activeTab from current tabs by title so it stays in sync when
    // tabs change (e.g. deviceType changes due to in-place route navigation).
    // Falls back to the first tab when the stored title is no longer present.
    const activeTab =
        tabs.find((t) => t.title === activeTabTitle) ?? tabs[0] ?? null;

    return (
        <TabContext.Provider
            value={{
                activeTab,
                setActiveTab: (tab) => setActiveTabTitle(tab?.title ?? null),
                tabs,
            }}
        >
            {children}
        </TabContext.Provider>
    );
};

export default TabProvider;
